
    import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';
    import _ from 'lodash';
    import ElgaPatient from '@/types/soap/elga/Patient';
    import api from '@/services/Api';
    import axios, { AxiosResponse, CancelTokenSource } from 'axios';
    import { errorSwal } from '@/helper/swals';
    import { VAutocomplete } from '@/types/Components';

    type PatientenSearchItem = ElgaPatient | { divider?: boolean };

    @Component
    export default class PatientSsnoSearch extends Vue {
        @Model('change') data!: PatientenSearchItem[];
        @Prop() ssno!: string;

        public $refs!: {
            search: VAutocomplete;
        };

        public search = null;
        public select: PatientenSearchItem | null = null;
        public loading = false;
        public patientAlreadyExists = false;
        public invalidSsno = true;

        public source: CancelTokenSource | null = null;
        public source2: CancelTokenSource | null = null;
        public searchApiCall: _.DebouncedFunc<(query: string) => void> | null = null;

        @Watch('search', { immediate: true })
        public onChangeSearch(val: string | null): void {
            val && this.querySelections(val);
            this.patientAlreadyExists = false;
        }

        @Watch('select')
        public onChangeSelect(select: PatientenSearchItem): void {
            this.$emit('select', select);
            this.$refs.search.blur();
        }

        public reset(): void {
            this.$refs.search.reset();
            this.$refs.search.blur();

            this.invalidSsno = true;
            this.loading = false;

            this.cancelSources();
            this.$emit('change', []);
        }

        public mounted(): void {
            this.search = null;
            this.select = null;
        }

        public destroyed(): void {
            this.cancelSources();
        }

        public cancelSources(): void {
            if (this.source) {
                this.source.cancel('cancel ivs/patienten/search');
            }
            if (this.source2) {
                this.source2.cancel('cancel ivs/impfpass/searchpatient');
            }
        }

        public querySelections(query: string): void {
            const svnr = query.trim();
            this.invalidSsno = !/^[0-9]{10}$/g.test(svnr);

            if (this.invalidSsno) {
                return;
            }

            this.loading = true;

            if (!this.searchApiCall) {
                this.searchApiCall = _.debounce((svnr: string) => {
                    if (this.source) {
                        this.source.cancel('cancel ivs/patienten/search');
                    }

                    this.source = axios.CancelToken.source();

                    api.post('ivs/patienten/search', { match: { svnr } }, { cancelToken: this.source.token })
                        .then(({ data }: AxiosResponse) => {
                            this.patientAlreadyExists = data.body.length !== 0;

                            if (this.patientAlreadyExists) {
                                this.loading = false;
                                this.$emit('change', []);
                                return;
                            }

                            if (this.source2) {
                                this.source2.cancel('cancel ivs/impfpass/searchpatient');
                            }

                            this.source2 = axios.CancelToken.source();

                            api.post('ivs/impfpass/searchpatient', { svnr }, { cancelToken: this.source2.token })
                                .then(({ data: { body } }: AxiosResponse) => {
                                    console.log('searchpatient(PatientSsnoSearch):', body);

                                    const items: PatientenSearchItem[] = [];

                                    if (typeof body !== 'string') {
                                        body.result
                                            .map((data: ElgaPatient) => new ElgaPatient(data))
                                            .forEach((patient: ElgaPatient, idx: number) => {
                                                items.push(patient);

                                                if (idx !== body.result.length - 1) {
                                                    items.push({ divider: true });
                                                }
                                            });
                                    } else {
                                        errorSwal('Fehler', body);
                                    }

                                    this.$emit('change', items);
                                    this.loading = false;
                                })
                                .catch(console.error)
                                .finally(() => {
                                    this.loading = false;
                                    this.source2 = null;
                                });
                        })
                        .catch(console.error)
                        .finally(() => this.source = null);
                }, 500);
            }

            this.searchApiCall(svnr);
        }
    }
